// extracted by mini-css-extract-plugin
module.exports = {"arrow":"SearchModesPopover_arrow__PMP5s"};